import { useState } from "react";

const TruncateText = ({ text, limit = 100 }) => {
  const [expanded, setExpanded] = useState(false)

  if (!text) return "-"

  const shouldTruncate = text.length > limit
  const displayText =
    expanded || !shouldTruncate ? text : text.substring(0, limit) + "..."

  return (
    <span>
      {displayText}
      {shouldTruncate && (
        <button
          type="button"
          className="btn btn-link p-0 ms-2"
          style={{ fontSize: "0.8rem" }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show less" : "Read more"}
        </button>
      )}
    </span>
  )
}

export default TruncateText
